import React, { useState, useMemo } from "react";
import { Row, Col } from "antd";
import {
  CheckOutlined,
  DoubleRightOutlined,
  EyeOutlined,
  PhoneOutlined,
  UserOutlined,
} from "@ant-design/icons";
import FilterSection from "./FilterSection";
import HotelCard from "./HotelCard";
import tourDetails from "../assets/images/tourDetails.webp";
import SortOptions from "./SortOptions";

const CategorySectionHotel = () => {
  // Example hotel data
  const hotels = [
    {
      id: 1,
      title: "Best of Switzerland & Italy with FREE Excursion to Mount Titlis",
      city: "Abu Dhabi",
      price: "INR 1,43,200",
      oldPrice: "INR 2,65,185",
      savings: "SAVE INR 1,21,985",
      star: 5,
      rating: 4.9,
      type: "Villa",
      location: "Anjuna",
      distance: "1.1 km drive to Anjuna Beach",
      image: tourDetails,
    },
    {
      id: 2,
      title: "Luxury Beachside Resort in Dubai",
      city: "Dubai",
      price: "INR 9,000",
      oldPrice: "INR 12,000",
      savings: "SAVE INR 3,000",
      star: 4,
      rating: 4.3,
      type: "Resort",
      location: "South Goa",
      distance: "500 m from Beach",
      image: tourDetails,
    },
    {
      id: 3,
      title: "Cozy Apartment near Sharjah Mall",
      city: "Sharjah",
      price: "INR 3,500",
      oldPrice: "INR 5,000",
      savings: "SAVE INR 1,500",
      star: 3,
      rating: 3.8,
      type: "Apartment",
      location: "Sharjah Central",
      distance: "2 km from City Center",
      image: tourDetails,
    },
  ];

  // Filter state
  const [selectedFilters, setSelectedFilters] = useState({
    cities: [],
    priceRange: [0, Infinity],
    stars: [],
    ratings: [],
    propertyTypes: [],
  });

  // Filter logic
  const filteredHotels = useMemo(() => {
    return hotels.filter((hotel) => {
      const { cities, priceRange, stars, ratings, propertyTypes } =
        selectedFilters;

      const priceValue = parseInt(hotel.price.replace(/[^\d]/g, "")); // convert "INR 9,000" to 9000

      // City filter
      if (cities.length && !cities.includes(hotel.city)) return false;

      // Price range filter
      if (priceValue < priceRange[0] || priceValue > priceRange[1])
        return false;

      // Star filter
      if (stars.length && !stars.includes(hotel.star)) return false;

      // Rating filter
      if (ratings.length && !ratings.some((r) => hotel.rating >= r))
        return false;

      // Property type filter
      if (propertyTypes.length && !propertyTypes.includes(hotel.type))
        return false;

      return true;
    });
  }, [hotels, selectedFilters]);

  return (
    <div className="container">
      <div className="flex justify-between align-middle items-center mb-4">
        <h2 className="font-medium text-danger">
          <span className="text-primary">2659 Properties in </span> Goa
        </h2>
      </div>
      <SortOptions />
      <h2 className="text-sm font-medium mb-4">
        {filteredHotels.length} Hotels Found{" "}
        <span className="text-danger">({hotels.length} Total)</span>
      </h2>

      <div className="flex gap-6">
        {/* Hotels List */}
        <div className="flex-1 border border-gray-200 p-4 rounded-lg bg-white">
          <Row gutter={[16, 16]}>
            {filteredHotels.map((hotel) => (
              <Col xs={24} sm={12} lg={12} key={hotel.id}>
                <HotelCard hotel={hotel} />
              </Col>
            ))}
            {filteredHotels.length === 0 && (
              <div className="text-center w-full text-gray-500 py-10">
                No hotels match your filters.
              </div>
            )}
          </Row>
        </div>

        {/* Sidebar Filters */}
        <FilterSection
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
        />
      </div>
    </div>
  );
};

export default CategorySectionHotel;
